export const news = {
  newsFeedCreateInputPlaceholder: 'Escreva uma postagem...',
  newsFeedSearchInputPlaceholder: 'Pesquisar',
  newsFeedPostOwnerCurtainEditTitle: 'Editar postagem',
  newsFeedPostOwnerCurtainDeleteTitle: 'Excluir postagem',
  newsFeedEditedPostSavedAlertText: 'Postagem salva!',
  newsFeedEditedPostDeletedAlertText: 'Postagem excluída!',
  newsFeedShareCurtainOptionTitle: 'Copiar link',
  newsFeedPostLinkCopiedAlertText: 'Link copiado!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Copiar link',
  newsFeedOthersPosLinkCopiedAlertText: 'Link copiado!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Sinalizar conteúdo',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Excluir postagem',
  newsFeedPostDeletePopupTitle: 'Excluir',
  newsFeedPostDeletePopupText: 'Tem certeza de que deseja excluir esta postagem?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Cancelar',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Confirmar',
  newsFeedPostDeeletedAlertText: 'Postagem excluída!',
  newsPostDetailsHeaderTitle: 'Postagem',
  postFeedPostLikesText: 'Curtidas',
  postFeedPostCommentsText: 'Comentários',
  postFeedPostNoLikesText: 'Ainda não há curtidas',
  postFeedPostLeaveFirstLikeText: 'Você pode ser o primeiro a curtir',
  newsFeedPostDetailsNoCommentsText: 'Ainda não há comentários',
  newsFeedPostDetailsFirstCommentText: 'Você pode ser o primeiro a comentar',
  newsFeedPostDetailsShareOptionTitle: 'Copiar link',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Link copiado!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copiar link',
  newsFeedPostDetailsCopiedAlertText: 'Link copiado!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Sinalizar conteúdo',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Sinalizar',
  newsPostDetailsReportedCurtainText: 'Conteúdo sinalizado',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Editar comentário',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Excluir comentário',
  newsPostDetailsEditedCommentSavedAlertText: 'Comentário salvo!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Excluir comentário',
  postDetailsOtherUsersCommentDeletadAlertText: 'Comentário excluído!',
  postDetailsDeleteCommentPopupTitle: 'Excluir',
  postDetailsDeleteCommentPopupText: 'Tem certeza de que deseja excluir este comentário?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Cancelar',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmar',
  postDetailsCommDeletedAlertText: 'Comentário excluído!',
  postDetailsCommentUserCurtainOptionTitle: 'Sinalizar comentário',
  newsCreatePostCurtainTitle: 'Nova postagem',
  newsCreatePostCurtainBodyPlaceholder: 'Escreva sua postagem aqui...',
  newsCreatePostPublishButtonTitle: 'Publicar',
  newsCreatePostUploadSlallerImageAlertText: 'Você só pode fazer upload de até {size} MB por vez',
  newsPostSavedAlertText: 'Postagem salva!',
  newsCreatePostAddLocationCurtainTitle: 'Localização',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Nome do local',
  newsCreatePostEditLocationCurtainText: 'Editar localização',
  newsDeleteLocation: 'Excluir localização',
  newsDiscardPostPopupTitle: 'Rascunho',
  newsDiscardPostPopupText: 'Descartar este rascunho?',
  newsDiscardPostPopupCancelButtonTitle: 'Cancelar',
  newsDiscardPostPopupCofirmButtonTitle: 'Confirmar',
  newsNewPostCreatePollTitle: 'Criar enquete',
  newsNewPostCreatePollTitleInputPlaceholder: 'Título',
  newsNewPostCreatePollOptionInputPlaceholder: 'Opção',
  newsNewPostCreatePollAddButtonTitle: 'Adicionar opção',
  newsNewPostCreatePollCreateButtonTitle: 'Criar',
  newsCreatePostPollTitleBlankAlertText: 'O título não pode estar em branco!',
  newsCreatePostPollOptionBlankAlertText: 'A opção não pode estar em branco!',
  newsCreatePostPollLongTitleAlertText: 'O título pode conter no máximo {length} caracteres',
  newsCreatePostPollLongOptionAlertText: 'A opção pode conter no máximo {length} caracteres',
  newsCreatePostPollEditOptionTitle: 'Editar enquete',
  newsCreatePostPollRemoveOptionTitle: 'Remover enquete',
  newsPostPollInfoVotesText: 'votos',
  newsPostPollInfoEditVoteText: 'Editar voto',
  newsPostPollFinishPollText: 'Encerrar enquete',
  newsPostPollFinishedPollText: 'Encerrada',
  newsPostPollInProgresslText: 'Em andamento',
  newsFinishPollCurtainTitle: 'Encerrar enquete',
  newsFinishPollCurtainText: 'Os usuários não poderão mais votar após o encerramento da enquete.',
  newsFinishPollCurtainCancelButtonTitle: 'Cancelar',
  newsFinishPollCurtainConfirmlButtonTitle: 'Confirmar',
  newsPollInfoPollVotesCurtainTitle: 'Votos da enquete',
  newsEditPostCurtainTitle: 'Editar postagem',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Escreva sua postagem aqui...',
  newsEditPostCurtainSaveButtonTitle: 'Salvar',
  newsEditPostSavedAlertText: 'Postagem salva!',
  newsError: 'Algo deu errado!',
  newsAt: 'em',
  newsSeeMore: 'Ver mais...',
  newsMaxAttachments: 'Você excedeu o número máximo de anexos. O máximo de anexos é {length}',
  newsReply: 'Responder',
  newsPin: 'Fixar postagem',
  newsUnpin: 'Desafixar postagem'
}
